import toggle from './nav-toggle.js';
import siteMap from './site-map.js';
import './search.js';

( function( $ ) {

    $( document ).ready( function() {

        $( 'body' ).removeClass( 'no-js' );

        let navToggle = new toggle();
        navToggle.init();

        let navigation = new siteMap();
        navigation.init();

        var selectmenu = document.getElementById("page_id");

        function onPageChange() {

            if ( selectmenu.options[selectmenu.selectedIndex].value > 0 ) {
                location.href = "?page_id="+selectmenu.options[selectmenu.selectedIndex].value;
            }

        }

        if ( selectmenu ) {
            selectmenu.onchange = onPageChange;
        }

    });

})( jQuery );